export default "__VITE_ASSET__Y9kds09q__"